<template>
  <div class="user-training-collection">
    <div class="success-percentage">
      <div class="progress-pipes desktop">
        <div
          v-for="index in totalPipes"
          :key="index"
          class="pipe"
          :class="{
            completed: index <= completedPipes
          }"
        ></div>
      </div>
      <div class="progress-pipes mobile">
        <div
          v-for="index in totalPipesMobile"
          :key="index"
          class="pipe"
          :class="{
            completed: index <= completedPipesMobile
          }"
        ></div>
      </div>
      <div class="progress-text">
        {{ successPercentage }}% afgerond
        <!-- ({{ successfulTrainings }}/{{ totalTrainings }}) -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { useTrainingProgress } from '@/composables/userTrainingProgress'
import { onMounted } from 'vue'

const props = defineProps({
  triggerGetTrainingProgress: {
    type: Boolean,
    default: false
  }
})

const {
  // totalTrainings,
  // successfulTrainings,
  successPercentage,
  completedPipes,
  totalPipes,
  totalPipesMobile,
  completedPipesMobile,
  triggerGetTrainingProgress
} = useTrainingProgress()

onMounted(() => {
  if (props.triggerGetTrainingProgress) {
    triggerGetTrainingProgress()
  }
})
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
